import { render, staticRenderFns } from "./queryForm.vue?vue&type=template&id=37bd4c12&scoped=true"
import script from "./queryForm.vue?vue&type=script&lang=js"
export * from "./queryForm.vue?vue&type=script&lang=js"
import style0 from "./queryForm.vue?vue&type=style&index=0&id=37bd4c12&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37bd4c12",
  null
  
)

export default component.exports